import * as THREE from "three";
import { GetSettings } from "./Settings";
import { UnifyEngine } from "../unify-three/UnifyEngine";

// Function takes in main (camera & audio files access), objects, volume
exports.Unify = function(unify) {
  this.unify_id = "positionalSounds";

  const settings = GetSettings();

  unify.assetLoader.loadAudio("audio/electroStatic.mp3", "evilAudio");
  unify.assetLoader.loadAudio("audio/heroSound3.mp3", "happyAudio");

  const listener = new THREE.AudioListener();
  unify.camera.add(listener);

  // Set up empty array for the new sounds created for each object
  let evilSoundBuffers = [];
  let happySoundBuffers = [];
  let arePlaying = false;

  this.start = () => {
    evilSoundBuffers.push(unify.assets.audioBuffers.evilAudio);
    happySoundBuffers.push(unify.assets.audioBuffers.happyAudio);
    this.createSoundObjects(unify.assets.evilTuneNuggets, evilSoundBuffers, settings.evilSoundControls);
    this.createSoundObjects(unify.assets.happyTuneNuggets, happySoundBuffers, settings.happySoundControls);

    unify.input.addKeyDown(toggleVolume, "q");
    // subscribe gameLogic world state event
    unify.modules.gameLogic.addEvent_WorldState(setState);
  };

  const setState = state => {
    switch (state) {
      case -1:
        if (arePlaying) {
          console.log("PLAY");
          this.stopTuneNuggets(unify.assets.evilTuneNuggets);
          this.stopTuneNuggets(unify.assets.happyTuneNuggets);
        }
        break;
      case 0:
        if (!arePlaying) {
          this.playTuneNuggets(unify.assets.evilTuneNuggets);
          this.playTuneNuggets(unify.assets.happyTuneNuggets);
        }
        break;
      case 1:
        break;
      case 2:
        break;
    }
  };

  // Loop through array of objects and create a sound object for each
  this.createSoundObjects = (objectArray, bufferArray, settingsType) => {
    if (objectArray != null) {
      for (let i = 0; i < objectArray.length; i++) {
        let sound = new THREE.PositionalAudio(listener);

        // determine which soundBuffer to use
        let audioIndex = i % bufferArray.length;

        //console.log(audioIndex);
        //console.log(bufferArray[audioIndex]);
        sound.setBuffer(bufferArray[audioIndex]);

        //sound.isPlaying = false;

        // Set up roll-off controls based on settings type
        this.setSoundControls(sound, settingsType);

        // Finally, add this sound to that object
        objectArray[i].sound = sound;
        objectArray[i].dummyMesh.add(sound);
      }
    }
  };

  this.playTuneNuggets = objectArray => {
    if (objectArray != null) {
      objectArray.forEach(nugget => {
        nugget.sound.setLoop(true);
        nugget.sound.setVolume(settings.globalVolume);
        nugget.sound.play();
        arePlaying = true;
      });
    }
  };

  this.stopTuneNuggets = objectArray => {
    if (objectArray != null) {
      objectArray.forEach(nugget => {
        nugget.sound.setLoop(true);
        nugget.sound.setVolume(settings.globalVolume);
        nugget.sound.pause();
        arePlaying = false;
      });
    }
  };

  this.setSoundControls = (sound, settingsType) => {
    // Roll off for dimming sound effect
    sound.setDistanceModel(settingsType.distanceModel);
    sound.setRefDistance(settingsType.refDistance);
    sound.setMaxDistance(settingsType.maxDistance);
    sound.setRolloffFactor(settingsType.rollOffFactor);
  };

  const toggleVolume = function() {
    if (listener.getMasterVolume() == 0) listener.setMasterVolume(1);
    else listener.setMasterVolume(0);
  };
};
